import { CircularProgress } from "@mui/material";
import React from "react";
import axiosHandler from "../../../utils/axiosHandler.ts";
import { RateRequestEntryPage } from "../../../federation/pages";
import { useNavigate } from "react-router-dom";

const RateRequest = () => {
  const navigate = useNavigate();

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <RateRequestEntryPage axiosHandler={axiosHandler} navigate={navigate} />
    </React.Suspense>
  );
};

export default RateRequest;
